import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CustomDateFormat } from '../main/CustomDateFormat';
import { DatePipe } from '@angular/common';
import { CommonFunction } from '../../app/main/CommonFunction';

@Component({
    selector: 'pay-receipt-template',
    template: require('./PayReceiptAdjustmentTemplate.html'),
    styles: [``]
})

export class PayReceiptAdjustmentTemplateComponent implements OnInit {

    static parameters = [UtilityService, HotkeysService, NgbModal, NgbModalConfig, HttpClient, CustomDateFormat, DatePipe, CommonFunction];
    
    @Input('PartyType') PartyType: any;
    @Input('Doc_No') Doc_No: any;
    @Input('Party_ID') Party_ID: any;
    @Input("dValue") dvalue: any;
    @Input("FI_ID") FI_ID: any;

    gridPayReceiptApi: any;
    paginationConf:any;
    gridPayReceiptColumnApi: any;
    PayReceiptList: any;
    PayReceiptColDef: any;
    rowSelectionSingle: string;
    unitInfo: any;
    d :any;
    defaultColDef:any;
    public hotkeyList: Hotkey[];
    public hotkeyListModal: Hotkey[];
    busy: Subscription;
    DISCOUNTREVERSALAPPLY: any =0;

    constructor(public utilityService: UtilityService, private hotkeysService: HotkeysService, private modalService: NgbModal, config: NgbModalConfig,private http: HttpClient,public customDateFormat: CustomDateFormat,public datePipe: DatePipe ,public commonFunction : CommonFunction) {
        this.hotkeysService = hotkeysService;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
    }

    ngOnInit(): void {
        this.d = this.dvalue;
      //   console.log('payment receipt init!');
        this.rowSelectionSingle = "single";        
        this.paginationConf = true;
        this.PayReceiptList = [];
        this.initHotkeys();
        this.getAdjustmentDetails();
        this.DISCOUNTREVERSALAPPLY = 0;
        if ("SystemConfigDetails" in localStorage) {
            var SystemConfigDetails = JSON.parse(localStorage.getItem('SystemConfigDetails'));
            var DISCOUNTREVERSALAPPLY = SystemConfigDetails.filter(function (item) {
                return item.Config_Name === 'Discount Reversal/Apply On Receipt'
            });
            if (DISCOUNTREVERSALAPPLY.length > 0) {
                this.DISCOUNTREVERSALAPPLY = this.f_chkNum(DISCOUNTREVERSALAPPLY[0].Config_Value);
            }
        };
    }

    ngAfterViewInit() {
        this.paginationConf =true;
    }

    onPayReceiptGridReady(params){
        this.PayReceiptColDef = [
            { headerName: 'Doc Type', field: 'DocType_Code' },
            { headerName: 'Doc No', field: 'Doc_No' },            
            { headerName: 'Doc Date', field: 'Post_Date' },
            { headerName: 'Due Date', field: 'Due_Date' },
            { headerName: 'Over Days', field: 'OverDays', cellStyle: {'text-align': 'right'} },
            { headerName: 'Amount', field: 'Total_BillAmount', cellStyle: {'text-align': 'right'} },
            { headerName: 'Adjusted', field: 'adjustedAmount', cellStyle: {'text-align': 'right'} },
            { headerName: 'Discount', field: 'discountAmount', cellStyle: {'text-align': 'right'}},
            { headerName: 'Disc. Reversal', field: 'Excess_Discount', cellStyle: {'text-align': 'right'}, hide: !(this.DISCOUNTREVERSALAPPLY)},
        ];
       
        this.gridPayReceiptApi = params.api;
        this.gridPayReceiptColumnApi = params.columnApi;
        this.gridPayReceiptApi.sizeColumnsToFit();
        this.defaultColDef = {
            resizable: true,
            sortable : true,
        };
    }

    initHotkeys() {
        this.hotkeyList = [];
        this.hotkeyListModal = [];
    }

    ngOnDestroy() {
        this.hotkeysService.remove(this.hotkeyList);
    }  
  
    getAdjustmentDetails() {
        var Data = {
            "Company_ID": this.unitInfo.Company_ID,
            "Unit_ID": this.unitInfo.Unit_ID,
            "Doc_No": this.Doc_No,
            "Party_ID": this.Party_ID,
            "PartyType": this.PartyType,
            "FI_ID": this.FI_ID,
        }
      //   console.log("data", Data);
        this.busy = this.http.post('/api/vendors/GetPayReceiptAdjustmentDetails', Data)
            .subscribe(response => {
                this.PayReceiptList = response;
                if(this.PayReceiptList.length > 0){
                    let parent = this;
                    setTimeout(() => {
                        var BottomTotal = { "DocType_Code": "Total Count : "+ this.PayReceiptList.length, "Total_BillAmount": 0, "adjustedAmount": 0, "discountAmount": 0, "Excess_Discount": 0};

                        BottomTotal.Total_BillAmount = (this.PayReceiptList.reduce(function (acc, sum) {
                            return acc + parent.f_chkNum(sum.Total_BillAmount);
                        }, 0)).toFixed(2);
                        
                        BottomTotal.adjustedAmount = (this.PayReceiptList.reduce(function (acc, sum) {
                            return acc + parent.f_chkNum(sum.adjustedAmount);
                        }, 0)).toFixed(2);
                        
                        BottomTotal.discountAmount = (this.PayReceiptList.reduce(function (acc, sum) {
                            return acc + parent.f_chkNum(sum.discountAmount);
                        }, 0)).toFixed(2);
                        
                        BottomTotal.Excess_Discount = (this.PayReceiptList.reduce(function (acc, sum) {
                            return acc + parent.f_chkNum(sum.Excess_Discount);
                        }, 0)).toFixed(2);

                        setTimeout(() => {
                            this.gridPayReceiptApi.setPinnedBottomRowData([BottomTotal]);
                        }, 300);

                        this.gridPayReceiptApi.sizeColumnsToFit();
                        this.gridPayReceiptApi.getModel().getRow(0).setSelected(true);
                        this.gridPayReceiptApi.setFocusedCell(0, "Doc_No");
                        
                    }, 200);
                }
            })
    }

    f_chkNum(p_value) {
        var Val = Number(p_value);
        if (Val) {
            return Val;
        }
        return 0;
    }
}